// v.29MAR21 : add .queueMsg()
export class Result {
    constructor() {
        this.kind = 'Result';
        this.subkind = '';
        this.ok = 0;
        this.data = {};
        this.misc = {};
        this.success_msg = "";
        this.error_msg = "";
        this.msg = "";
    }
    from_ws_msg(e) {
        let _r = JSON.parse(e.data);
        Object.keys(_r).forEach(k => this[k] = _r[k]);
    }
    from_json(r) {
        Object.keys(r).forEach(k => this[k] = r[k]);
    }
    has_event(e) {
        if (Array.isArray(this.misc['(|)_EVENTS']))
            return this.misc['(|)_EVENTS'].includes(e);
        else
            return false;
    }
    process_calls() {
        if (Array.isArray(this.misc['(|)_CALLS'])) {
            this.misc['(|)_CALLS'].forEach(item => {
                const fn = item[0].split('.');
                if (fn.length == 1 && window[fn[0]])
                    window[fn[0]].apply(this, item[1]);
                else if (fn.length == 2 && window[fn[0]][fn[1]])
                    window[fn[0]][fn[1]].apply(this, item[1]);
            });
            return true;
        }
        else
            return false;
    }
    queueMsg(t, q) {
        if (this.ok) {
            if (this.msg in t)
                q.push({ level: 'success', text: t[this.msg] });
            else
                q.push({ level: 'success', text: this.msg });
        }
        else {
            if (this.msg in t)
                q.push({ level: 'danger', text: t[this.msg] });
            else
                q.push({ level: 'danger', text: this.msg });
        }
        return q;
    }
}
